import { Component, OnInit, Inject } from "@angular/core";
import { Router } from "@angular/router";
import { AngularFirestore } from "@angular/fire/firestore";
import {
  MAT_BOTTOM_SHEET_DATA,
  MatBottomSheetRef,
} from "@angular/material/bottom-sheet";

import {
  DraftStatus,
  LanguageDraft,
} from "../Models/language-models.interface";

@Component({
  selector: "app-admin-languages-bottom-sheet",
  templateUrl: "./admin-languages-bottom-sheet.component.html",
  styleUrls: ["./admin-languages-bottom-sheet.component.css"],
})
export class AdminLanguagesBottomSheetComponent implements OnInit {
  constructor(
    private afs: AngularFirestore,
    private router: Router,

    @Inject(MAT_BOTTOM_SHEET_DATA)
    public data: {
      language: LanguageDraft;
      isAdmin: boolean;
    },
    private _bottomSheetRef: MatBottomSheetRef<AdminLanguagesBottomSheetComponent>
  ) {
    this.data.isAdmin = this.data.isAdmin ?? false;
  }
  DraftStatus = DraftStatus;

  ngOnInit(): void {}
  gotoConfigEditor = (event) => {
    if (this.data?.language?.status === DraftStatus.EDITING) {
      this._bottomSheetRef.dismiss();
      this.router.navigate(["config-editor", this.data.language.code]);
    } else {
      alert("This Language needs to be in editing mode to be configured");
    }
  };

  gotoLessonEditor = (event) => {
    if (this.data?.language?.status === DraftStatus.EDITING) {
      this._bottomSheetRef.dismiss();
      this.router.navigate(["lesson-editor", this.data.language.code]);
    } else {
      alert("This Language needs to be in editing mode to be configured");
    }
  };

  publish = (event) => {};
  submit = (event) => {};
}
